import { render } from "./HomeContact.vue?vue&type=template&id=07f3a4ae&scoped=true"
import script from "./HomeContact.vue?vue&type=script&lang=js"
export * from "./HomeContact.vue?vue&type=script&lang=js"

import "./HomeContact.vue?vue&type=style&index=0&id=07f3a4ae&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f3a4ae"]])

export default __exports__